import ProductAwards, { ProductAwardsProps } from '@/components/_rebrand/ProductAwards';
import { parseHtml } from '@/lib/parse-html';
import Image from 'next/image';

const displayProps = {
  title: <span>Your team deserves the best. <span className="hidden md:inline"><br /></span> <span className="font-serif">So do your customers.</span></span>,
  description: 'From AI automation to ease of use, Front wins more G2 categories than other top support tools combined. ',
  image:
    <Image
      src="https://front.com/webassets/rebrand/product-awards-image-2025-v2.webp"
      width={1434}
      height={1061}
      alt="Product awards"
      className="block w-full"
    />,

  awardBadges: [
    <Image
      key="badge-1"
      width={83}
      height={107}
      src="https://front.com/assets/award-badges/g2-summer-2026-enterprise-higher-performer.svg"
      className="block w-[83px] md:w-[94px] h-auto"
      alt="g2-high-performer-enterprise-winter-2026"
    />,
    <Image
      key="badge-2"
      width={83}
      height={107}
      src="https://front.com/assets/award-badges/g2-summer-2026-momentum-leader.svg"
      className="block w-[83px] md:w-[94px]"
      alt="g2-momentum-leader-enterprise-winter-2026"
    />,
    <Image
      key="badge-3"
      width={83}
      height={107}
      src="https://front.com/assets/award-badges/g2-summer-2026-enterprise-easiest-to-do-business-wirth.svg"
      className="block w-[83px] md:w-[94px]"
      alt="g2-easiest-to-do-business-with-enterprise-winter-2026"
    />,
    <Image
      key="badge-4"
      width={83}
      height={107}
      src="https://front.com/assets/award-badges/g2-summer-2026-enterprise-easiest-to-use.svg"
      className="block w-[83px] md:w-[94px]"
      alt="g2-easiest-to-use-enterprise-winter-2026"
    />,
    <Image
      key="badge-5"
      width={83}
      height={107}
      src="https://front.com/assets/award-badges/g2-summer-2026-mid-market-best-relationship.svg"
      className="block w-[83px] md:w-[94px]"
      alt="g2-mid-market-best-relationship-winter-2026"
    />,
  ],
  showTileBreakup: false,
  styleOverrides: undefined,
  containerBackgroundColor: 'bg-white',
} as ProductAwardsProps;


interface AssetImageFromCraft {
  url: string;
  title: string;
  alt: string;
  width: number;
  height: number;
}

interface BulletFromCraft {
  heading: string;
  image: AssetImageFromCraft;
  description: string;
}

const formFeaturedAwards = (features: BulletFromCraft[]): ProductAwardsProps['featuredAwards'] => {
  const featuredAwards: ProductAwardsProps['featuredAwards'] = features.map((feature) => ({
    icon: <Image src={feature.image[0].url} width={feature.image[0].width} height={feature.image[0].height} style={{ width: 40 }} alt={feature.image[0].title} />,
    title: feature.heading,
    description: parseHtml(feature.description),
  }));

  return featuredAwards;
}

const formMainImage = (featuredImage: AssetImageFromCraft): ProductAwardsProps['image'] => {
  return <Image src={featuredImage.url} width={featuredImage.width} height={featuredImage.height} alt={featuredImage.alt} className="block w-full" />
}

const formTitle = (headerSansSerif: string, headerSerif: string) => {
  if (headerSansSerif && headerSansSerif.length > 0 && headerSerif && headerSerif.length > 0) {
    return (
      <span>{headerSansSerif} <span className="hidden md:inline"><br /></span> <span className="font-serif">{headerSerif}</span></span>)
  }

  if (headerSansSerif && headerSansSerif.length > 0) {
    return (
      <span>{headerSansSerif}</span>)
  }

  if (headerSerif && headerSerif.length > 0) {
    return (
      <span className="font-serif">{headerSerif}</span>
    )
  }

  return null;
}

const setDynamicDisplayPropAttributes = (entry: any) => {
  displayProps.title = formTitle(entry.headerSansSerif, entry.headerSerif);
  displayProps.featuredAwards = formFeaturedAwards(entry.bullets);
  displayProps.image = formMainImage(entry.image[0]);
  displayProps.description = parseHtml(entry.description);
  displayProps.styleOverrides = {
    bottomMarginSpacing: 'none',
    topMarginSpacing: 'none'
  };
  return;
}

const ProductValidation = ({ entry }) => {
  if (entry.__typename != 'comparisonModules_g2Validation_BlockType') {
    return null;
  }

  setDynamicDisplayPropAttributes(entry);

  return (
    <div className="bg-white">
      <ProductAwards {...displayProps} />
    </div>
  );
};

export default ProductValidation;
